var _g, _defs, _defs2, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg76071153670299(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#C6E3FF"
    },
    d: "M646.88,310.419c-3.562-6.02-0.714-13.99,3.983-19.174 c4.697-5.184,10.98-8.674,15.969-13.578c8.921-8.769,13.097-22.101,10.774-34.393c-2.323-12.291-11.078-23.18-22.584-28.087 c-15.91-6.786-37.158-3.452-47.983-16.943c-7.256-9.042-6.365-22.121-3.321-33.308c3.044-11.187,7.902-22.224,7.388-33.806 c-1.131-25.5-29.271-43.188-54.741-41.509c-25.47,1.679-47.773,17.335-66.935,34.197c-5.543,4.878-11.184,10.043-18.207,12.321 c-7.023,2.279-15.903,0.748-19.776-5.538c-2.021-3.28-2.419-7.34-4.319-10.692c-6.005-10.593-22.335-8.16-32.373-1.267 c-10.038,6.892-18.879,17.068-30.977,18.447c-15.185,1.731-28.088-11.427-34.864-25.126 c-6.776-13.699-10.334-29.288-20.204-40.956c-15.587-18.426-46.265-21.427-65.127-6.371 c-13.921,11.112-20.273,28.856-28.417,44.698c-8.144,15.842-20.94,31.889-38.686,33.425 c-21.884,1.893-39.73-18.968-61.588-21.141c-18.738-1.863-36.933,11.448-44.111,28.856c-7.178,17.408-4.651,37.707,3.243,54.802 c7.787,16.864,20.913,33.44,17.635,51.723c-3.29,18.352-22.104,30.309-27.5,48.155c-4.445,14.705,1.264,30.974,10.975,42.877 c9.711,11.903,22.968,20.284,35.98,28.45l501.081,17.918c15.628-13.038,26.251-30.952,36.566-48.497 c3.191-5.428,6.478-11.908,4.056-17.721C668.678,318.253,652.359,319.678,646.88,310.419z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M647.076,309.248c-3.562-6.02-0.714-13.99,3.983-19.174c4.697-5.184,10.98-8.674,15.969-13.578 c8.921-8.769,13.097-22.101,10.774-34.393s-11.078-23.18-22.584-28.088c-15.91-6.786-37.158-3.452-47.983-16.943 c-7.256-9.042-6.365-22.121-3.321-33.308c3.044-11.187,7.901-22.224,7.388-33.806c-1.131-25.5-29.271-43.188-54.741-41.509 c-25.47,1.679-47.773,17.335-66.935,34.197c-5.543,4.878-11.184,10.043-18.207,12.321c-7.023,2.278-15.903,0.748-19.776-5.538 c-2.021-3.28-2.419-7.34-4.319-10.692c-6.005-10.593-22.335-8.16-32.373-1.267c-10.038,6.892-18.879,17.068-30.977,18.447 c-15.185,1.731-28.088-11.427-34.864-25.126c-6.776-13.699-10.334-29.288-20.204-40.956 c-15.587-18.426-46.265-21.427-65.127-6.371c-13.922,11.112-20.273,28.856-28.417,44.698 c-8.144,15.842-20.94,31.889-38.686,33.425c-21.884,1.893-39.73-18.968-61.588-21.141 c-18.738-1.863-36.933,11.448-44.111,28.856c-7.178,17.408-4.651,37.707,3.243,54.803c7.787,16.863,20.913,33.44,17.635,51.723 c-3.29,18.351-22.104,30.309-27.499,48.155c-4.446,14.705,1.264,30.973,10.975,42.877c9.711,11.903,22.968,20.284,35.98,28.45 l501.081,17.918c15.628-13.038,26.251-30.952,36.566-48.497c3.191-5.428,6.478-11.909,4.056-17.721 C668.873,317.082,652.554,318.507,647.076,309.248z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000069378138750099957150000014120324198977293500_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000069378138750099957150000014120324198977293500_)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.648,
    y: 216.572,
    style: {
      fill: "#FFFFFF"
    },
    width: 93.456,
    height: 131.234
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.648,
    y: 78.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 93.456,
    height: 131.234
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.114,
    y: 216.572,
    style: {
      fill: "#FFFFFF"
    },
    width: 93.456,
    height: 131.234
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.114,
    y: 78.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 93.456,
    height: 131.234
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000069378138750099957150000014120324198977293500_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E3FF"
    },
    d: "M235.76,51.845c0,0-1.023,106.472-69.067,174.36c0,0,23.022,150.916,26.092,182.663h-73.671 c0,0,11.255-140.172,15.348-180.709c0,0-8.697-135.776-10.744-177.779L235.76,51.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E3FF"
    },
    d: "M260.108,51.845c0,0,1.023,106.472,69.067,174.36c0,0-23.022,150.916-26.092,182.663h73.671 c0,0-11.255-140.172-15.348-180.709c0,0,8.697-135.776,10.744-177.779L260.108,51.845z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 544.963,
    y: 169.366,
    style: {
      fill: "#ADDCFF"
    },
    width: 12.274,
    height: 51.915
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.899,
    y: 176.148,
    style: {
      fill: "#C6E3FF"
    },
    width: 12.274,
    height: 45.134
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.878,
    y: 182.02,
    style: {
      fill: "#C6E3FF"
    },
    width: 8.326,
    height: 39.262
  }), /*#__PURE__*/React.createElement("rect", {
    x: 568.739,
    y: 181.635,
    style: {
      fill: "#ADDCFF"
    },
    width: 6.547,
    height: 39.647
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E3FF"
    },
    d: "M629.941,189.195c-0.554-0.917-1.718-1.191-2.623-0.775c-0.489,0.225-0.898,0.62-1.218,1.1 c1.084-2.714,1.533-5.759,1.258-8.727c-0.074-0.797-0.223-1.645-0.725-2.204c-0.88-0.979-2.453-0.543-3.253,0.521 c-0.285,0.379-0.496,0.81-0.662,1.268c0.225-1.421,0.323-2.869,0.256-4.311c-0.043-0.924-0.351-2.087-1.159-2.157 c-0.556-0.048-1.009,0.486-1.339,1.001c-1.242,1.938-2.012,4.266-2.203,6.659c0.483-4.348,0.957-8.846-0.134-13.048 c-0.215-0.828-0.502-1.659-1.026-2.282c-0.523-0.623-1.331-0.996-2.052-0.741c-0.936,0.331-1.391,1.521-1.664,2.597 c-0.772,3.046-0.99,6.261-0.696,9.414c-0.136-0.295-0.284-0.583-0.448-0.861c-0.451-0.763-1.11-1.497-1.916-1.491 c-0.626,0.004-1.196,0.476-1.534,1.078c-0.338,0.602-0.479,1.32-0.57,2.028c-0.368,2.857,0.001,5.827,1.025,8.466 c-0.42-0.557-1.02-0.941-1.663-0.999c-1.06-0.095-2.134,0.697-2.495,1.841c-0.298,0.946-0.131,1.999,0.141,2.956 c1.902,6.698,8.317,11.133,14.369,10.316c2.683-0.362,5.243-1.72,7.264-3.761 C628.445,195.499,631.499,191.775,629.941,189.195z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6E3FF"
    },
    points: "626.082,220.309 608.568,220.309 604.526,199.73 630.124,199.73  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.631,
    y: 218.407,
    style: {
      fill: "#ADDCFF"
    },
    width: 19.301,
    height: 2.529
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.804,
    y: 196.231,
    style: {
      fill: "#ADDCFF"
    },
    width: 26.956,
    height: 5.682
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.211,
    y: 220.831,
    style: {
      fill: "#C6E3FF"
    },
    width: 142.043,
    height: 3.494
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.133,
    y: 224.326,
    style: {
      fill: "#C6E3FF"
    },
    width: 138.199,
    height: 10.134
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 463.873,
    y: 124.511,
    style: {
      fill: "#C6E3FF"
    },
    width: 32.8,
    height: 16.306
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.206,
    y: 140.817,
    style: {
      fill: "#ADDCFF"
    },
    width: 34.134,
    height: 2.39
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M488.846,137.69H471.7c-1.289,0-2.334-1.045-2.334-2.334v-4.811 c0-1.289,1.045-2.334,2.334-2.334h17.146c1.289,0,2.334,1.045,2.334,2.334v4.811 C491.18,136.645,490.135,137.69,488.846,137.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADDCFF"
    },
    d: "M491.718,100.566c-1.345-0.046-3.185-0.634-4.464-3.122 c-0.253-0.491-0.06-1.094,0.432-1.347c0.491-0.252,1.094-0.059,1.346,0.432c0.676,1.313,1.602,1.999,2.755,2.038 c0.015,0,0.028,0,0.042,0.001c2.125,0.043,4.868-2.046,6.523-4.967c1.71-3.018,1.567-6.258,0.543-7.899 c-0.477-0.765-1.093-1.129-1.846-1.083c-1.483,0.09-2.32,1.262-3.131,2.394c-0.767,1.072-1.614,2.278-3.089,2.116 c-0.548-0.065-0.939-0.563-0.874-1.111c0.065-0.548,0.554-0.94,1.111-0.875c0.253,0.038,0.803-0.7,1.225-1.293 c0.929-1.298,2.201-3.077,4.635-3.226c1.483-0.089,2.794,0.626,3.664,2.02c1.585,2.538,1.38,6.628-0.5,9.944 c-2.06,3.636-5.397,6.039-8.303,5.98C491.765,100.567,491.742,100.566,491.718,100.566z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADDCFF"
    },
    d: "M468.827,100.566c1.345-0.046,3.185-0.634,4.464-3.122c0.253-0.491,0.06-1.094-0.431-1.347 c-0.491-0.252-1.095-0.059-1.346,0.432c-0.676,1.313-1.602,1.999-2.755,2.038c-0.015,0-0.028,0-0.042,0.001 c-2.125,0.043-4.868-2.046-6.523-4.967c-1.71-3.018-1.567-6.258-0.543-7.899c0.477-0.765,1.093-1.129,1.846-1.083 c1.483,0.09,2.32,1.262,3.131,2.394c0.767,1.072,1.614,2.278,3.089,2.116c0.548-0.065,0.939-0.563,0.874-1.111 c-0.065-0.548-0.554-0.94-1.111-0.875c-0.253,0.038-0.803-0.7-1.225-1.293c-0.929-1.298-2.201-3.077-4.635-3.226 c-1.483-0.089-2.794,0.626-3.664,2.02c-1.585,2.538-1.38,6.628,0.5,9.944c2.06,3.636,5.397,6.039,8.303,5.98 C468.78,100.567,468.804,100.566,468.827,100.566z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADDCFF"
    },
    d: "M491.43,122.009h-22.315c-0.422,0-0.764,0.342-0.764,0.764v0.973 c0,0.422,0.342,0.764,0.764,0.764h22.315c0.422,0,0.765-0.342,0.765-0.764v-0.973 C492.195,122.352,491.853,122.009,491.43,122.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E3FF"
    },
    d: "M489.336,120.923l-2.242-1.788c-2.213-1.765-3.519-4.414-3.599-7.234 c1.101-0.924,1.816-2.294,1.816-3.844c0-1.059-0.33-2.04-0.889-2.851c7.743-3.558,9.181-17.171,9.268-25.469h-26.835 c0.087,8.298,1.525,21.91,9.268,25.469c-0.559,0.811-0.889,1.792-0.889,2.851c0,1.55,0.715,2.92,1.816,3.844 c-0.08,2.82-1.386,5.47-3.599,7.234l-2.242,1.788c-0.522,0.341-0.255,1.087,0.389,1.087h17.348 C489.59,122.009,489.857,121.264,489.336,120.923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADDCFF"
    },
    d: "M493.384,78.121h-26.223c-0.691,0-1.251,0.56-1.251,1.251l0,0c0,0.691,0.56,1.251,1.251,1.251 h26.223c0.691,0,1.251-0.56,1.251-1.251l0,0C494.635,78.681,494.075,78.121,493.384,78.121z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 438.096,
    y: 142.657,
    style: {
      fill: "#C6E3FF"
    },
    width: 142.043,
    height: 3.494
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.018,
    y: 146.151,
    style: {
      fill: "#C6E3FF"
    },
    width: 138.199,
    height: 10.133
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADDCFF"
    },
    d: "M544.067,109.429h6.9c0.393,0,0.706,0.23,0.801,0.588l8.223,31.109 c0.174,0.66-0.446,1.405-1.169,1.405h-6.9c-0.393,0-0.706-0.23-0.801-0.589l-8.223-31.109 C542.724,110.174,543.344,109.429,544.067,109.429z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ADDCFF"
    },
    points: "556.436,97.65 523.284,97.65 516.259,142.6 549.411,142.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6E3FF"
    },
    points: "554.564,97.65 521.413,97.65 514.387,142.6 547.539,142.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "549.697,101.8 524.982,101.8 519.255,138.449 543.969,138.449  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6E3FF"
    },
    points: "542.18,108.835 530.3,108.835 526.771,131.414 538.651,131.414  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB145"
    },
    d: "M319.145,283.187c-1.419-10.886,2.342-20.387,13.742-20.387s17.981,13.658,19.401,24.544 c1.419,10.886,9.155,59.263,12.73,62.35c6.362,5.493,45.366-0.236,53.148,5.74c7.782,5.976,17.02,47.702,10.375,55.026 c-6.645,7.324-74.768,7.917-85.8,0C331.708,402.542,320.564,294.074,319.145,283.187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "#FFB145"
    },
    d: "M319.145,283.187c-1.419-10.886,2.342-20.387,13.742-20.387 s17.981,13.658,19.401,24.544c1.419,10.886,9.155,59.263,12.73,62.35c6.362,5.493,45.366-0.236,53.148,5.74 c7.782,5.976,17.02,47.702,10.375,55.026c-6.645,7.324-74.768,7.917-85.8,0C331.708,402.542,320.564,294.074,319.145,283.187z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB145"
    },
    d: "M199.93,274.828c3.688-8.299,19.944-16.119,68.302-16.119s63.931,4.645,67.482,10.382 c3.552,5.737,36.61,136.331,28.14,142.888c-8.469,6.557-125.129,10.109-137.15,0.546 C214.683,402.963,197.744,279.746,199.93,274.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFB145"
    },
    d: "M335.714,269.091c-0.898-1.451-2.569-2.831-5.339-4.084 c8.737,37.934-13.907,75.467-43.023,98.46c-14.449,11.411-32.717,20.742-51.659,18.948c-7.861-0.745-14.919-3.59-21.542-7.728 c4.148,19.374,8.615,34.706,12.553,37.839c12.021,9.562,128.681,6.011,137.15-0.546 C372.324,405.422,339.266,274.828,335.714,269.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "#FFB145"
    },
    d: "M202.843,279.313c5.1-2.737,10.49-5.119,15.81-7.386 c13.08-5.573,26.664-8.381,40.78-9.703c15.642-1.465,31.366-1.156,47.044-0.564c4.209,0.159,8.422,0.297,12.57,0.142 c-10.374-1.908-26.418-3.091-50.815-3.091c-48.358,0-64.613,7.82-68.302,16.119c-0.255,0.574-0.247,2.774-0.019,6.2 C200.853,280.41,201.847,279.847,202.843,279.313z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF8DB"
    },
    d: "M323.952,353.99c1.488-5.037,2.532-10.205,3.131-15.422c1.21-10.528,0.618-21.265-1.774-31.59 c-1.366-5.897-3.32-11.66-5.856-17.158c-0.482-1.045-1.042-2.144-2.046-2.705c-1.005-0.561-2.565-0.245-2.868,0.865 c-20.548-8.634-44.498-8.829-65.184-0.531c-4.032,1.617-8.172,3.582-12.498,3.191c-1.535-0.139-3.055-0.576-4.592-0.462 c-1.537,0.114-3.18,0.986-3.527,2.487c-0.347,1.502,1.44,3.2,2.731,2.358c-4.586,18.078-3.923,37.456,1.888,55.179 c1.434,4.373,3.194,9.006,1.984,13.446c-0.397,1.455-1.109,2.968-0.643,4.402s2.967,1.966,3.313,0.497 c18.685,12.318,43.094,15.514,64.32,8.424c5.479-1.83,10.722-4.293,15.95-6.749c1.6-0.752,3.334-1.638,4.014-3.271 c0.785-1.886-1.186-3.472-0.964-5.384C321.612,359.151,323.25,356.365,323.952,353.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF8DB"
    },
    d: "M323.952,353.99c1.318-4.46,2.266-9.024,2.887-13.633c-4.497,0.977-9.063,1.656-13.6,2.148 c-15.646,1.7-31.82,0.623-46.963-3.763c-12.561-3.639-24.387-10.431-32.739-20.64c-1.677-2.05-3.298-4.334-4.749-6.773 c-1.05,13.091,0.477,26.393,4.57,38.875c1.434,4.373,3.194,9.006,1.984,13.446c-0.397,1.455-1.109,2.968-0.643,4.402 s2.967,1.966,3.313,0.497c18.685,12.318,43.094,15.514,64.32,8.424c5.479-1.83,10.722-4.293,15.95-6.749 c1.6-0.752,3.334-1.638,4.014-3.271c0.785-1.886-1.186-3.472-0.964-5.384C321.612,359.151,323.25,356.365,323.952,353.99z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC9B0"
    },
    d: "M379.83,296.686c0,0,27.222,39.584,30.719,42.106c3.496,2.522,59.618,27.251,59.618,27.251 l-18.036,21.31c0,0-61.756-23.999-66.362-29.265c-4.605-5.267-31.139-43.315-31.139-43.315L379.83,296.686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFC9B0"
    },
    d: "M379.83,296.686c0,0,27.222,39.584,30.719,42.106 c3.496,2.522,59.618,27.251,59.618,27.251l-18.036,21.31c0,0-61.756-23.999-66.362-29.265 c-4.605-5.267-31.139-43.315-31.139-43.315L379.83,296.686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC9B0"
    },
    d: "M378.127,329.858c3.238-2.605,5.81-5.955,7.868-9.543c1.72-2.998,2.953-6.129,3.706-9.442 c-5.48-7.803-9.871-14.188-9.871-14.188l-25.199,18.087c0,0,6.621,9.494,13.822,19.654 C371.853,333.234,375.152,332.252,378.127,329.858z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC9B0"
    },
    d: "M320.449,269.522c6.123-0.584,11.722-3.437,14.539-9.033c1.317-2.616,1.492-5.285,1.327-7.982 c-4.424-0.884-9.254-1.976-13.511-3.228c-11.701-3.441-13.015-2.426-18.669,0.315c-2.298,1.114-6.792,2.953-11.422,4.82 C298.838,263.947,308.764,270.636,320.449,269.522z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC9B0"
    },
    d: "M336.314,252.507c-1.166-0.233-2.362-0.482-3.567-0.743 c-2.699,4.503-7.293,8.569-10.496,10.404c-3.7,2.119-11.651,4.59-17.792,3.771c4.716,2.739,10.132,4.143,15.99,3.584 c6.123-0.584,11.722-3.437,14.539-9.033C336.305,257.873,336.48,255.204,336.314,252.507z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000173866029586926655920000000150682431904565897_",
    points: "328.845,230.882 302.674,226.385  301.076,254.577 326.048,258.728  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173866029586926655920000000150682431904565897_",
    style: {
      overflow: "visible",
      fill: "#FFC9B0"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129197128373331584670000012423380852676208283_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173866029586926655920000000150682431904565897_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129197128373331584670000012423380852676208283_)",
      fill: "#FFC9B0"
    },
    d: "M334.443,248.46 c-21.344,0.974-31.85-23.694-31.296-24.735c0.688-1.294,2.741-1.219,4.419-0.881c11.822,2.378,28.468,8.754,30.604,13.985 C340.307,242.06,337.455,248.323,334.443,248.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB4F4F"
    },
    d: "M353.126,181.571c0.648,1.068,0.947,2.308,1.162,3.538c0.546,3.122,0.606,6.329,0.179,9.469 c-0.187,1.372-0.478,2.762-1.194,3.948c-0.997,1.651-2.71,2.73-4.438,3.587c-1.07,0.53-2.32,1.004-3.426,0.555 c-0.738-0.3-1.268-0.968-1.635-1.676c-1.28-2.469-0.906-5.433-0.483-8.181c0.405-2.636,0.833-5.302,1.887-7.752 c0.785-1.824,1.954-3.552,3.544-4.769C350.465,178.955,352.015,179.739,353.126,181.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.64,
      fill: "#FB4F4F"
    },
    d: "M353.126,181.571c0.648,1.068,0.947,2.308,1.162,3.538 c0.546,3.122,0.606,6.329,0.179,9.469c-0.187,1.372-0.478,2.762-1.194,3.948c-0.997,1.651-2.71,2.73-4.438,3.587 c-1.07,0.53-2.32,1.004-3.426,0.555c-0.738-0.3-1.268-0.968-1.635-1.676c-1.28-2.469-0.906-5.433-0.483-8.181 c0.405-2.636,0.833-5.302,1.887-7.752c0.785-1.824,1.954-3.552,3.544-4.769C350.465,178.955,352.015,179.739,353.126,181.571 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC9B0"
    },
    d: "M351.66,215.96c-0.01,0.03-0.01,0.07-0.02,0.1c-0.06,0.32-0.12,0.63-0.17,0.94 c-0.69,3.58-3.03,12.55-5.76,18.07c-0.34,0.68-0.68,1.3-1.02,1.86c-3.8,6.17-8.33,8.22-19.84,5.34 c-20.29-5.07-36.09-27.86-25.93-52.77c0.23-0.55,0.47-1.1,0.71-1.63c3.25-6.97,8.75-12.76,15.17-15.85 c17-8.18,37.01,2.52,37.87,27.35C352.86,205.21,352.55,210.82,351.66,215.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFC9B0"
    },
    d: "M352.67,199.37c-0.273-7.868-2.472-14.313-5.886-19.192 c3.357,24.419-2.948,43.518-7.326,51.09c-2.342,4.051-5.706,8.313-9.702,11.983c7.989,1.141,11.73-1.118,14.934-6.32 c0.34-0.56,0.68-1.18,1.02-1.86c2.73-5.52,5.07-14.49,5.76-18.07c0.05-0.31,0.11-0.62,0.17-0.94 c0.01-0.03,0.01-0.07,0.02-0.1C352.55,210.82,352.86,205.21,352.67,199.37z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB4F4F"
    },
    d: "M351.64,216.06c-0.06,0.32-0.12,0.63-0.17,0.94c-0.69,3.58-3.03,12.55-5.76,18.07 c-1.2-0.14-2.36-0.65-3.03-1.63c-0.69-1.02-0.72-2.35-0.6-3.59c0.41-4.39,2.36-8.63,5.43-11.8 C348.62,216.9,350.1,215.84,351.64,216.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB4F4F"
    },
    d: "M311.117,229.542c-0.25-0.197-0.489-0.399-0.716-0.604 c-3.796-3.423-8.094-10.463-4.239-15.746c1.905-2.61,5.463-3.307,8.273-2.195c2.81,1.112,4.917,3.714,6.284,6.607 c1.02,2.16,1.697,4.588,1.517,7.043c-0.18,2.456-1.316,4.932-3.259,6.238C316.417,232.604,313.35,231.302,311.117,229.542z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB4F4F"
    },
    d: "M358.94,174.41c0.02,3.28-2.33,6.3-5.35,7.75c-4.67,2.26-7.84,2.08-15.26,1.18 c-0.56-0.07-1.14-0.17-1.73-0.3c-7.11-1.52-15.63-6.68-21.06-3.5c-3.7,2.16-5.62,5.72-6.37,9.39 c-0.45,2.17-0.48,4.37-0.23,6.35c0.69,5.31,0.46,6.64,0.59,9.14c-0.72,2.41-1.72,4.87-4.21,4.79 c-2.05-0.07-3.56-4.74-5.58-5.02c-1.4-0.2-2.21,0.89-3.08,1.75c-0.42,0.41-0.95,0.78-1.55,0.81 c-0.27,0.02-0.54-0.04-0.81-0.13c-2.45-7.5-4.49-15.67-2.64-23.5c0.06-0.28,0.13-0.56,0.21-0.84 c0.01-0.05,0.03-0.1,0.04-0.15c0.15-0.53,0.32-1.05,0.5-1.55c1.91-5.32,5.71-9.73,10.45-12.87c0.57-0.39,1.16-0.75,1.76-1.09 c3.28-1.89,6.94-3.21,10.69-3.86c3.41-0.6,6.9-0.65,10.26-0.07c1.41,0.24,2.83,0.73,4.11,1.36c0.54,0.26,3.2,1.53,3.21,2.17 c-0.02-1.95,2.18-3.59,4.11-3.08c1.93,0.52,2.95,3.03,1.9,4.69c1.79-2.28,3.59-4.56,5.38-6.83c0.89-1.14,2.27-2.42,3.62-1.85 c0.94,0.4,1.29,1.51,1.4,2.49c0.27,2.28-0.18,4.64-1.26,6.68c0.74-1.17,1.77-2.37,2.98-1.61c1.7,1.06-0.12,3.66-0.83,5.29 c1.42-1.28,3.09-2.66,5.01-2.46C357.47,169.77,358.92,172.19,358.94,174.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.64,
      fill: "#FB4F4F"
    },
    d: "M356.061,169.745c-1.259,4.107-4.339,7.456-8.971,8.805 c-3.875,1.129-8.096,0.994-12.07,0.595c-3.928-0.394-8.048-1.554-12.083-1.792c-1.583,0.235-3.173,0.487-4.692,1.095 c-0.239,0.096-0.467,0.208-0.701,0.312c5.883-1.362,14.165,3.77,20.79,4.578c7.416,0.904,10.582,1.078,15.26-1.177 c3.021-1.456,5.363-4.474,5.344-7.753C358.926,172.484,357.831,170.411,356.061,169.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.64,
      fill: "#FB4F4F"
    },
    d: "M312.602,181.919c-1.486,1.342-2.734,2.939-3.647,4.815 c-3.423,7.023,0.479,15.798-3.074,22.443c2.082-0.279,2.987-2.534,3.645-4.753c-0.127-2.502,0.1-3.838-0.584-9.148 C308.39,191.002,309.2,185.641,312.602,181.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FB4F4F"
    },
    d: "M325.78,173.98c-0.49,0.69-1.19,1.16-1.93,1.53c-2.28,1.18-4.91,1.59-7.32,2.51 c-3.15,1.22-5.9,3.33-7.94,6.11c-0.44,0.61-0.86,1.26-1.49,1.66c-0.62,0.39-1.51,0.47-2.18-0.05 c-0.56-0.45-0.85-1.22-1.37-1.73c-0.9-0.92-2.3-0.81-3.15-0.12s-1.29,1.81-1.69,2.9c-0.32,0.85-0.79,1.81-1.67,1.84 c-1.08,0.03-1.92-1.3-2.25-2.46c-0.32-1.16-0.48-2.47-1.33-3.34c-0.45-0.45-1-0.67-1.55-0.7c0.15-0.53,0.32-1.05,0.5-1.55 c1.91-5.32,5.71-9.73,10.45-12.87c0.34,0.29,0.69,0.54,1.08,0.7c1.09,0.44,2.21,0.11,3.1-0.42c0.91-0.53,1.7-1.27,2.65-1.71 c0.71-0.32,1.74-0.36,2.23,0.41c0.21,0.32,0.27,0.71,0.44,1.06c0.34,0.72,1.14,1.11,1.84,1.16c0.7,0.06,1.37-0.16,2.03-0.33 c1.7-0.44,3.52-0.57,5.34-0.37c0.96,0.09,1.93,0.3,2.81,0.81c0.89,0.51,1.67,1.39,1.92,2.42 C326.52,172.36,326.26,173.3,325.78,173.98z"
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M343.714,211.488c-0.247,1.583,0.327,2.987,1.282,3.136c0.955,0.149,1.93-1.013,2.177-2.596 c0.247-1.583-0.327-2.987-1.283-3.136C344.935,208.742,343.961,209.905,343.714,211.488z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320.766,208.491c-0.247,1.583,0.327,2.987,1.283,3.136c0.955,0.149,1.93-1.013,2.177-2.596 c0.247-1.583-0.327-2.987-1.282-3.136S321.013,206.908,320.766,208.491z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B92513"
    },
    d: "M337.614,224.207c-2.461-0.194-4.935-0.781-7.16-1.863c-2.23-1.085-4.119-2.598-5.929-4.274 c-0.153-0.141-0.427,0.044-0.301,0.232c2.816,4.201,8.427,6.606,13.39,6.413 C337.943,224.702,337.937,224.232,337.614,224.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B92513"
    },
    d: "M338.723,215.303c-0.559-0.506-1.195-0.891-1.884-1.181c0.462-1.56,0.915-3.122,1.355-4.689 c0.451-1.604,0.914-3.205,1.132-4.861c0.028-0.214-0.278-0.212-0.345-0.047c-0.639,1.568-1.048,3.211-1.504,4.838 c-0.455,1.626-0.923,3.247-1.402,4.866c-0.057,0.191,0.069,0.37,0.246,0.432c0.644,0.227,1.251,0.544,1.783,0.975 c0.471,0.382,1.204,1.006,1.207,1.67c0.002,0.657-0.756,1.256-1.227,1.625c-0.549,0.431-1.177,0.766-1.832,1.005 c-0.275,0.1-0.167,0.526,0.123,0.444c0.826-0.233,1.573-0.605,2.242-1.146c0.575-0.465,1.307-1.124,1.308-1.928 C339.926,216.509,339.277,215.805,338.723,215.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB4F4F"
    },
    d: "M343.487,199.78c-0.546,1.672,1.449,1.467,4.432,2.505c2.983,1.037,3.172,4.24,4.072,4.111 c0.9-0.13,0.776-5.754-3.078-7.689C345.965,197.226,343.847,198.676,343.487,199.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB4F4F"
    },
    d: "M334.639,198.039c0.106,1.632-3.907,0.682-8.394,0.005c-4.486-0.677-8.216,2.934-8.559,1.496 c-0.343-1.438,3.447-5.746,8.966-5.514C332.172,194.257,334.569,196.961,334.639,198.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.64,
      fill: "#FB4F4F"
    },
    d: "M343.487,199.78c-0.546,1.672,1.449,1.467,4.432,2.505 c2.983,1.037,3.172,4.24,4.072,4.111c0.9-0.13,0.776-5.754-3.078-7.689C345.965,197.226,343.847,198.676,343.487,199.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.64,
      fill: "#FB4F4F"
    },
    d: "M334.639,198.039c0.106,1.632-3.907,0.682-8.394,0.005 c-4.486-0.677-8.216,2.934-8.559,1.496c-0.343-1.438,3.447-5.746,8.966-5.514 C332.172,194.257,334.569,196.961,334.639,198.039z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC9B0"
    },
    d: "M302.507,206.327c-1.53-4.096-4.723-7.382-9.295-5.902c-1.487,0.481-2.599,1.805-3.114,3.281 c-0.514,1.476-0.495,3.089-0.267,4.635c0.574,3.903,2.572,7.703,5.86,9.883c1.244,0.825,2.816,1.414,4.219,0.903 c1.924-0.7,2.913-2.839,3.355-4.703C303.806,212.143,303.526,209.055,302.507,206.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFC9B0"
    },
    d: "M297.397,202.546c1.117,1.168,1.725,2.783,2.796,3.924 c0.753,0.802,1.235,1.984,2.521,0.627c0.012-0.013,0.022-0.034,0.034-0.048c-0.077-0.242-0.153-0.484-0.242-0.722 c-1.433-3.837-4.326-6.961-8.443-6.127C295.292,200.693,296.426,201.531,297.397,202.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B92513"
    },
    d: "M292.982,204.295c0.428-0.307,0.954-0.436,1.472-0.403c1.201,0.076,2.22,0.922,2.859,1.902 c0.664,1.018,1.121,2.224,1.489,3.38c0.383,1.208,0.563,2.488,0.487,3.758c-0.015,0.253-0.44,0.247-0.443-0.008 c-0.03-2.087-0.827-4.212-1.819-6.017c-0.152-0.277-0.331-0.546-0.524-0.805c-0.606,0.865-0.956,1.893-1.019,2.952 c-0.076,1.279,0.22,2.438,0.616,3.637c0.04,0.121-0.121,0.222-0.199,0.111c-1.474-2.108-1.38-5.137,0.269-7.113 c-0.355-0.379-0.773-0.686-1.277-0.842c-0.788-0.244-1.9,0.017-2.367,0.751c-0.087,0.137-0.338,0.027-0.294-0.132 C292.367,204.991,292.577,204.585,292.982,204.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M296.625,206.248c-1.097-0.504-2.482-0.303-3.391,0.492c-0.909,0.796-1.291,2.142-0.935,3.296 c0.298,0.968,1.036,1.727,1.749,2.447c2.641,2.664,7.517,8.051,8.137,8.178c0.621,0.127,2.156-1.297,1.961-2.066 s-3.763-3.89-4.818-6.074C298.302,210.396,299.378,207.454,296.625,206.248z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M359.288,331.071c12.936-0.808,23.408-11.306,30.46-21.821 c1.288-1.921,2.378-3.851,3.332-5.793c-6.036-10.956-12.07-21.911-18.113-32.87c-2.155-3.909-5.168-7.392-8.687-10.133 c-1.754-1.366-4.772-3.805-6.883-4.508c-3.567-1.189-5.816,6.853-6.135,9.63c-0.335,2.915-0.631,5.837-0.905,8.759 c-0.555,5.916-0.96,11.85-1.001,17.793c-0.013,0.401-0.013,0.79-0.013,1.192c0,12.608,1.43,25.668,6.173,34.488 C358.112,328.917,358.702,330.002,359.288,331.071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#393B6B"
    },
    d: "M359.288,331.071c12.936-0.808,23.408-11.306,30.46-21.821 c1.288-1.921,2.378-3.851,3.332-5.793c-6.036-10.956-12.07-21.911-18.113-32.87c-2.155-3.909-5.168-7.392-8.687-10.133 c-1.754-1.366-4.772-3.805-6.883-4.508c-3.567-1.189-5.816,6.853-6.135,9.63c-0.335,2.915-0.631,5.837-0.905,8.759 c-0.555,5.916-0.96,11.85-1.001,17.793c-0.013,0.401-0.013,0.79-0.013,1.192c0,12.608,1.43,25.668,6.173,34.488 C358.112,328.917,358.702,330.002,359.288,331.071z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M365.295,292.655c-0.728-15.199-2.414-33.252-5.787-36.625 c-1.586-1.586-23.465-4.143-27.5-4.586c-0.322-0.035-0.552,0.279-0.445,0.585c1.629,4.649-0.12,9.889-9.825,10.907 c-11.039,1.158-17.723-2.933-25.858-9.866c-1.275-1.087-29.51,10.024-32.525,15.289c-5.608,9.796,7.046,50.596,8.617,67.179 c1.571,16.583-0.791,39.757-2.75,52.445c15.133,2.683,70.597,9.114,89.885-2.341 C365.295,381.967,366.023,307.854,365.295,292.655z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.333,267.4c13.2-1.933,11.133-13.467,10.058-15.684c-1.036-0.121-1.861-0.215-2.383-0.272 c-0.322-0.035-0.552,0.279-0.445,0.584c1.629,4.649-0.12,9.889-9.825,10.907c-11.039,1.158-17.723-2.933-25.858-9.866 c-0.354-0.302-2.79,0.339-6.185,1.532C298.733,264.933,311.133,269.333,324.333,267.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#393B6B"
    },
    d: "M365.295,292.655c-0.728-15.199-2.414-33.252-5.787-36.625 c-0.984-0.984-9.791-2.343-17.294-3.338c2.132,5.929,2.64,13.248,3.025,19.146c0.475,7.285,0.194,14.617-1.037,21.819 c-2.598,15.199-9.37,29.831-17.648,42.75c-7.936,12.386-18.133,22.997-31.353,29.708c-7.767,3.943-15.878,6.162-24.177,7.611 c-0.554,5.417-1.197,10.339-1.802,14.258c15.133,2.683,70.597,9.114,89.885-2.341 C365.295,381.967,366.023,307.854,365.295,292.655z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M367.021,286.479c0.375-0.985,0.628-2.02,0.524-3.124c-0.655,0.888-1.061,1.816-1.451,2.752 c-0.284,0.727-0.53,1.454-0.751,2.225l-0.424-4.67c-0.233-2.161-0.432-4.324-0.694-6.479c0.037,2.177,0.138,4.345,0.206,6.516 l0.31,6.501c0.271,4.326,0.258,8.659,0.272,13l0.083,13.019c0.035,4.341,0.058,8.683,0.16,13.029 c0.31-4.336,0.481-8.678,0.606-13.021c0.128-4.343,0.136-8.688,0.15-13.034l-0.13-6.52c-0.063-2.173-0.139-4.355-0.372-6.516 l-0.12-1.326C366.156,288.206,366.657,287.347,367.021,286.479z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC9B0"
    },
    d: "M410.535,350.949c-0.825-5.128-3.648-9.791-7.306-13.479c-1.12-1.13-2.343-2.194-3.786-2.864 c-2.915-1.353-6.657-1.221-9.76-0.766c-3.956,0.58-7.765,1.951-11.581,3.084c-3.56,1.057-7.119,2.119-10.669,3.211 c-0.807,0.248-1.867,0.807-2.708,0.842c-6.89,0.29-49.815,2.068-57.365,1.596c-5.904-9.754-12.813-34.909-12.813-34.909 s-21.344,0.726-30.208,13.353c0-0.364,17.41,42.16,20.747,44.727c3.337,2.567,21.033,1.144,42.852-2.706 c16.513-2.914,30.942-6.218,36.986-7.653c0.78,0.328,1.667,0.591,2.676,0.772c10.761,1.932,10.458-5.093,11.065-5.444 l-0.201-0.427c1.948,1.033,3.919,2.023,5.929,2.929c0.813,0.366,1.935,0.65,2.457-0.072c0.408-0.563,0.128-1.347-0.177-1.972 c-1.019-2.083-2.21-4.081-3.558-5.967c3.017,2.948,6.035,5.896,9.052,8.843c0.6,0.586,1.46,1.216,2.194,0.81 c0.729-0.403,0.66-1.462,0.449-2.269c-1.021-3.907-3.017-7.555-5.758-10.52c1.986,2.219,3.973,4.437,5.959,6.656 c1.363,1.522,2.728,3.047,4.228,4.435c1.349,1.249,3.107,2.456,4.886,1.995c0.232-0.06,0.477-0.166,0.583-0.38 c0.099-0.201,0.049-0.44-0.006-0.657c-1.178-4.581-4.096-8.486-6.948-12.259c2.622,2.984,5.244,5.968,7.865,8.953 c1.012,1.151,2.306,2.413,3.82,2.173c0.328-0.052,0.656-0.185,0.87-0.438C410.669,352.122,410.623,351.497,410.535,350.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC9B0"
    },
    d: "M294.83,340.339c3.119-2.938,5.358-6.124,7.191-9.531c-4.069-10.76-7.472-23.144-7.472-23.144 s-21.344,0.726-30.208,13.353c0-0.236,7.31,17.535,13.365,30.775C284.01,350.156,290.575,344.345,294.83,340.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFC9B0"
    },
    d: "M379.277,348.478c-2.626,0.084-5.085,1.035-7.675,1.441 c-2.492,0.391-5.016,0.381-7.522,0.613c-6.742,0.624-13.389,2.511-19.948,4.121c-12.358,3.033-24.852,5.429-37.471,7.083 c-7.652,1.003-15.842,2.537-23.479,1.232c0.82,1.46,1.479,2.448,1.905,2.776c3.337,2.567,21.033,1.144,42.852-2.706 c16.513-2.914,30.942-6.218,36.986-7.653c0.78,0.328,1.667,0.591,2.676,0.772c10.761,1.932,10.458-5.093,11.065-5.444 l-0.201-0.427c1.948,1.033,3.919,2.023,5.929,2.929c0.518,0.234,1.161,0.43,1.696,0.357 C383.938,351.645,381.62,350.133,379.277,348.478z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M305.259,328.594c-1.337-3.21-11.462-31.971-14.788-42.622 c-1.748-5.617-3.825-11.329-7.69-15.864c-2.739-3.231-10.775-10.756-19.174-2.964c-0.444,0.411-0.874,0.85-1.289,1.29 c-0.461,0.509-0.893,1.033-1.298,1.572c-6.132,7.999-7.143,19.893-6.465,30.112c0.128,2.01,0.387,3.981,0.746,5.941 c2.264,12.581,7.108,28.503,12.656,40.375C278.397,346.882,297.985,338.78,305.259,328.594z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#393B6B"
    },
    d: "M286.471,276.32c-2.079-1.292-4.667-2.196-5.592,0.748 c-0.488,1.554,0.31,3.86,0.58,5.439c0.886,5.177,1.939,10.33,2.68,15.531c1.537,10.782,0.492,21.568-2.03,32.131 c-1.179,4.937-1.532,11.712-5.734,15.115c10.337-2.49,22.996-9.029,28.53-16.778c-1.337-3.21-11.461-31.971-14.788-42.622 C289.108,282.643,287.978,279.379,286.471,276.32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M301.805,317.852c-1.242-3.548-2.421-7.118-3.682-10.658c-1.276-3.536-2.47-7.1-3.78-10.625 c-1.272-3.538-2.564-7.067-3.872-10.597c0.952,3.643,2.053,7.242,3.188,10.829c1.105,3.597,2.358,7.143,3.548,10.711 c1.203,3.563,2.515,7.089,3.785,10.629c0.629,1.772,1.327,3.52,1.997,5.277c0.668,1.726,1.324,3.451,2.076,5.153 c-0.746,1.117-1.598,2.166-2.5,3.175c1.029-0.928,1.981-1.947,2.833-3.053l0.052-0.067l-0.033-0.098L301.805,317.852z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD245"
    },
    d: "M187.458,283.187c-1.42-10.886,2.342-20.387,13.742-20.387c11.4,0,17.981,13.658,19.4,24.544 c1.42,10.886,9.156,59.263,12.73,62.35c6.362,5.493,45.366-0.236,53.148,5.74c7.782,5.976,17.02,47.702,10.375,55.026 c-6.645,7.324-74.768,7.917-85.8,0C200.022,402.542,188.878,294.074,187.458,283.187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFD245"
    },
    d: "M286.479,355.434c-7.782-5.976-46.786-0.247-53.148-5.74 c-3.575-3.087-11.311-51.463-12.73-62.35c-1.229-9.429-6.334-20.93-15.085-23.842c1.996,3.12,3.454,6.994,4.066,8.777 c2.902,8.454,4.797,17.536,5.827,26.417c1.764,15.218-0.529,30.147-2.514,45.191c-1.255,9.507-3.307,23.6-13.509,27.217 c3.584,20.106,7.634,36.461,11.669,39.357c11.033,7.917,79.155,7.324,85.8,0C303.499,403.136,294.261,361.41,286.479,355.434z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 131.434,
    y: 408.158,
    style: {
      fill: "#73A3EB"
    },
    width: 512.745,
    height: 25.267
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.44,
    y: 408.154,
    style: {
      opacity: 0.49,
      fill: "#73A3EB"
    },
    width: 512.741,
    height: 14.63
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.255,
    y: 371.023,
    style: {
      fill: "#73A3EB"
    },
    width: 556.443,
    height: 46.325
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.589,
    y: 404.755,
    style: {
      opacity: 0.3,
      fill: "#73A3EB"
    },
    width: 556.443,
    height: 12.496
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#73A3EB"
    },
    cx: 429.781,
    cy: 375.712,
    rx: 92.474,
    ry: 3.491
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73A3EB"
    },
    d: "M412.944,436.733c-0.553,0-1-0.447-1-1v-23.068c0-9.514-4.432-13.945-13.945-13.945 c-6.664,0-11.276-1.275-13.711-3.791c-1.224-1.265-1.841-2.819-1.785-4.497c0.069-2.146,1.326-7.141,11.449-7.141 c15.909,0,22.943-0.626,22.943-2.741c0-2.116-4.036-2.449-6.441-2.449h-4.657c-0.553,0-1-0.447-1-1c0-0.553,0.447-1,1-1h4.657 c5.286,0,8.441,1.51,8.441,4.024c0,5.224-8.859,5.166-24.943,5.166c-5.984,0-9.341,1.849-9.451,5.206 c-0.037,1.14,0.375,2.163,1.225,3.041c1.404,1.451,4.674,3.182,12.273,3.182c10.58,0,15.945,5.365,15.945,15.945v23.068 C413.944,436.286,413.496,436.733,412.944,436.733z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7CF7E8"
    },
    d: "M536.142,287.703H429.055c-2.102,0-3.983,1.304-4.72,3.272l-28.774,76.81h115.372l28.319-75.596 C540.066,290.018,538.46,287.703,536.142,287.703z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.447,
    y: 367.786,
    style: {
      fill: "#7CF7E8"
    },
    width: 170.396,
    height: 7.99
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "#57D9CD"
    },
    d: "M364.738,374.694c-4.333-0.859-12.706-2.975-17.465-6.908h-2.826v7.99h26.514 C368.857,375.461,366.777,375.098,364.738,374.694z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.47,
    y: 367.786,
    style: {
      fill: "#57D9CD"
    },
    width: 115.372,
    height: 7.99
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57D9CD"
    },
    d: "M540.051,287.703H432.965c-2.102,0-3.983,1.304-4.72,3.272l-28.774,76.81h115.372l28.319-75.596 C543.975,290.018,542.37,287.703,540.051,287.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.22,
      fill: "#57D9CD"
    },
    d: "M540.051,287.703h-90.22c43.872,1.114,67.322,2.443,76.341,3.772 s15.095,3.323,13.521,9.976l3.469-9.261C543.975,290.018,542.37,287.703,540.051,287.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "#57D9CD"
    },
    d: "M515.414,361.414c-23.613,6.408-53.864,4.817-72.734-12.48 c-10.011-9.177-14.883-23.191-14.688-36.584c0.11-7.547,1.504-16.881,5.016-24.647h-0.044c-2.102,0-3.983,1.304-4.72,3.272 l-28.774,76.81h115.372l2.604-6.951C516.768,361.034,516.089,361.231,515.414,361.414z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M408.619,371.78c0,1.217-0.986,2.203-2.203,2.203c-1.216,0-2.203-0.986-2.203-2.203 c0-1.216,0.986-2.202,2.203-2.202C407.633,369.578,408.619,370.564,408.619,371.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73A3EB"
    },
    d: "M407.89,371.78c0,0.814-0.66,1.473-1.473,1.473s-1.473-0.66-1.473-1.473 c0-0.814,0.66-1.473,1.473-1.473S407.89,370.967,407.89,371.78z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD245"
    },
    d: "M413.817,435.423c-0.553,0-1-0.447-1-1v-23.068c0-9.514-4.432-13.945-13.945-13.945 c-6.664,0-11.276-1.275-13.711-3.791c-1.224-1.265-1.841-2.819-1.785-4.497c0.069-2.146,1.326-7.141,11.449-7.141 c15.909,0,22.943-0.205,22.943-5.072c0-3.553-4.036-4.083-6.441-4.083h-4.657c-0.553,0-1-0.447-1-1s0.447-1,1-1h4.657 c5.286,0,8.441,2.274,8.441,6.083c0,7.072-8.859,7.072-24.943,7.072c-5.984,0-9.341,1.849-9.451,5.206 c-0.037,1.14,0.375,2.163,1.225,3.041c1.404,1.451,4.674,3.182,12.273,3.182c10.58,0,15.945,5.365,15.945,15.945v23.068 C414.817,434.976,414.37,435.423,413.817,435.423z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD245"
    },
    d: "M412.548,407.681c0.174,1.13,0.269,2.347,0.269,3.673v23.068c0,0.553,0.447,1,1,1 c0.553,0,1-0.447,1-1v-23.068c0-1.866-0.176-3.561-0.509-5.101C413.811,406.802,413.212,407.294,412.548,407.681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M455.899,325.01c-2.395,8.386-10.272,14.868-17.594,14.477 c-7.322-0.391-11.317-7.506-8.923-15.892c2.394-8.386,10.272-14.868,17.594-14.477 C454.298,309.508,458.293,316.624,455.899,325.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.43,
      fill: "#FB4F4F"
    },
    d: "M453.478,324.881c-1.957,6.855-8.396,12.154-14.382,11.834 c-5.986-0.319-9.251-6.135-7.294-12.991c1.957-6.855,8.396-12.154,14.382-11.834 C452.17,312.209,455.436,318.026,453.478,324.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M472.146,331.386l-24.777,12.55c-1.098,0.556-2.185-0.013-2.429-1.271l-1.588-8.191 c-0.244-1.258,0.448-2.728,1.546-3.284l24.777-12.55c1.098-0.556,2.185,0.013,2.429,1.271l1.588,8.191 C473.935,329.36,473.243,330.83,472.146,331.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M471.341,330.65l-23.278,11.798c-0.919,0.465-1.829-0.011-2.033-1.064l-1.329-6.855 c-0.204-1.053,0.375-2.283,1.294-2.748l23.278-11.798c0.919-0.465,1.828,0.011,2.033,1.064l1.329,6.855 C472.839,328.954,472.259,330.184,471.341,330.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73A3EB"
    },
    d: "M470.201,324.447c-0.267-0.504-1.086-0.389-1.22,0.159c-0.215,0.88-0.072,1.785-0.264,2.676 c-0.066,0.308-0.146,1.045-0.393,1.236c-0.377,0.292-1.021-0.04-1.435-0.135c-1.65-0.378-2.704,0.176-3.801,1.393 c-0.428,0.475-0.677,0.618-1.298,0.373c-0.328-0.129-0.613-0.3-0.961-0.394c-0.783-0.212-1.631-0.193-2.41,0.029 c-1.277,0.364-2.424,1.272-3.146,2.398c-0.208-0.153-0.415-0.298-0.61-0.428c-1.345-0.892-3.07-1.502-4.599-0.678 c-2.825,1.522-3.619,6.688-0.718,8.514c0.734,0.462,1.376-0.672,0.674-1.153c-1.45-0.992-1.154-3.446-0.356-4.749 c1.086-1.772,2.786-1.365,4.257-0.31c0.243,0.174,0.451,0.367,0.65,0.566c-0.177,0.949-0.065,1.97,0.652,2.628 c1.058,0.971,2.534-0.068,2.343-1.389c-0.103-0.71-0.516-1.353-1.042-1.915c0.037-0.065,0.065-0.135,0.105-0.198 c0.856-1.335,2.576-2.298,4.134-1.613c1.183,0.52,1.988,0.93,3.068-0.09c0.518-0.489,0.901-1.221,1.613-1.444 c0.715-0.224,1.504,0.203,2.226,0.301c1.292,0.175,1.974-0.461,2.396-1.626C470.522,327.348,470.853,325.674,470.201,324.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD245"
    },
    d: "M449.079,323.159c-1.848,0.372-3.794-0.596-4.938-2.094c-1.144-1.497-1.581-3.434-1.616-5.318 c0.081,4.387-3.162,8.354-6.676,10.501c1.611-0.586,2.935-0.212,4.154,0.346c1.219,0.558,2.115,1.668,2.681,2.883 c0.566,1.215,0.837,2.542,1.104,3.856c-0.098-2.021,0.23-4.081,1.11-5.903C445.778,325.608,447.251,324.027,449.079,323.159z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3,
      fill: "#73A3EB"
    },
    cx: 493.464,
    cy: 387.226,
    rx: 49.961,
    ry: 3.491
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD245"
    },
    d: "M510.558,387.915v-13.082h-59.367c-1.282,0-2.321,1.039-2.321,2.321v8.441 c0,1.282,1.039,2.321,2.321,2.321H510.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD245"
    },
    d: "M498.216,374.833h-40.505c-0.66,2.829-1.028,10.099,0.26,13.082h40.206 C497.514,383.569,497.632,379.41,498.216,374.833z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD245"
    },
    points: "539.753,376.147 539.753,374.833 510.558,374.833 510.558,387.915 539.753,387.915  539.753,386.601 527.523,386.601 527.523,376.147  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD245"
    },
    points: "539.753,376.147 539.753,374.833 510.558,374.833 510.558,387.915 539.753,387.915  539.753,386.601 527.523,386.601 527.523,376.147  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFFAFF"
    },
    d: "M511.741,385.14v-7.531c0-0.807,0.654-1.462,1.462-1.462h25.528v10.454h-25.528 C512.396,386.601,511.741,385.947,511.741,385.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB4F4F"
    },
    d: "M507.915,375.138v-13.082h-59.367c-1.282,0-2.321,1.039-2.321,2.321v8.441 c0,1.282,1.039,2.321,2.321,2.321H507.915z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B92513"
    },
    points: "537.11,363.37 537.11,362.056 507.915,362.056 507.915,375.138 537.11,375.138  537.11,373.824 524.88,373.824 524.88,363.37  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFFAFF"
    },
    d: "M509.098,372.363v-7.531c0-0.807,0.654-1.462,1.462-1.462h25.528v10.454H510.56 C509.753,373.824,509.098,373.17,509.098,372.363z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B92513"
    },
    d: "M452.358,375.269L452.358,375.269c-0.712,0-1.288-0.577-1.288-1.288v-10.951 c0-0.712,0.577-1.288,1.288-1.288l0,0c0.711,0,1.288,0.577,1.288,1.288v10.951 C453.646,374.693,453.069,375.269,452.358,375.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B92513"
    },
    d: "M502.417,375.269L502.417,375.269c-0.711,0-1.288-0.577-1.288-1.288v-10.951 c0-0.712,0.577-1.288,1.288-1.288l0,0c0.712,0,1.288,0.577,1.288,1.288v10.951 C503.705,374.693,503.129,375.269,502.417,375.269z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3,
      fill: "#73A3EB"
    },
    cx: 596.214,
    cy: 386.445,
    rx: 32.633,
    ry: 3.491
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 593.643,
    y: 272.04,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 818.6964 902.0773)",
    style: {
      fill: "#393B6B"
    },
    width: 5.072,
    height: 18.875
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.807,
    y: 272.936,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 819.5856 904.2445)",
    style: {
      opacity: 0.33,
      fill: "#393B6B"
    },
    width: 2.536,
    height: 18.875
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.904,
    y: 262.675,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -30.9116 522.6512)",
    style: {
      fill: "#393B6B"
    },
    width: 5.072,
    height: 71.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.365,
    y: 261.656,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -29.8924 523.0734)",
    style: {
      opacity: 0.33,
      fill: "#393B6B"
    },
    width: 2.189,
    height: 71.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.596,
    y: 315.007,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 428.6349 -332.8738)",
    style: {
      fill: "#393B6B"
    },
    width: 5.072,
    height: 71.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.187,
    y: 316.081,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 429.6845 -333.3119)",
    style: {
      opacity: 0.33,
      fill: "#393B6B"
    },
    width: 2.036,
    height: 71.928
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M645.871,324.229c0,2.801-2.271,5.072-5.072,5.072s-5.072-2.271-5.072-5.072 c0-2.801,2.271-5.072,5.072-5.072S645.871,321.428,645.871,324.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#393B6B"
    },
    d: "M644.769,321.107c0.01,3.164-2.214,5.559-5.046,6.792 c-0.542,0.236-1.13,0.426-1.728,0.552c0.804,0.535,1.766,0.849,2.804,0.849c2.801,0,5.072-2.271,5.072-5.072 C645.871,323.045,645.449,321.97,644.769,321.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73A3EB"
    },
    d: "M643.669,324.229c0,1.585-1.285,2.87-2.87,2.87c-1.585,0-2.87-1.285-2.87-2.87 c0-1.585,1.285-2.87,2.87-2.87C642.384,321.359,643.669,322.644,643.669,324.229z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M602.016,280.578c0,2.801-2.271,5.072-5.072,5.072c-2.801,0-5.072-2.271-5.072-5.072 c0-2.801,2.271-5.072,5.072-5.072C599.746,275.506,602.016,277.777,602.016,280.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#393B6B"
    },
    d: "M600.914,277.456c0.01,3.164-2.214,5.559-5.046,6.792 c-0.542,0.236-1.13,0.426-1.728,0.552c0.804,0.535,1.766,0.849,2.804,0.849c2.801,0,5.072-2.271,5.072-5.072 C602.016,279.394,601.594,278.319,600.914,277.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73A3EB"
    },
    d: "M599.815,280.578c0,1.585-1.285,2.87-2.87,2.87c-1.585,0-2.87-1.285-2.87-2.87 c0-1.585,1.285-2.87,2.87-2.87C598.53,277.708,599.815,278.993,599.815,280.578z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M620.703,386.591h-54.419v-5.59c0-4.685,3.798-8.484,8.484-8.484h37.452 c4.685,0,8.483,3.798,8.483,8.484V386.591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#393B6B"
    },
    d: "M616.939,373.952c-2.933,2.393-6.788,4.232-9.465,5.287 c-6.606,2.603-13.603,3.965-20.645,4.727c-4.078,0.442-8.266,0.852-12.373,0.827c-2.799-0.017-5.474-0.467-8.172-0.898v2.697 h54.419v-5.59C620.703,378.063,619.209,375.474,616.939,373.952z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M585.852,388.456l3.92-67.83l-33.784-24.001L436.47,386.975 c-0.984,0.744-0.939,2.359,0.19,2.856C460.844,400.484,569.37,400.827,585.852,388.456z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M552.497,296.838l38.181,26.647c0,0,15.019-30.247-2.181-39.847 S552.497,296.838,552.497,296.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#393B6B"
    },
    d: "M588.497,283.638c-0.774-0.432-1.551-0.777-2.329-1.082 c3.825,7.346,2.183,17.864-0.366,25.111c-1.045,2.973-2.646,6.193-4.712,9.126l9.588,6.692 C590.678,323.485,605.697,293.238,588.497,283.638z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3,
      fill: "#73A3EB"
    },
    cx: 195.543,
    cy: 385.23,
    rx: 44.336,
    ry: 3.491
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D0E7FF"
    },
    points: "233.939,384.483 177.095,384.483 167.095,340.892 223.939,340.892  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#73A3EB"
    },
    d: "M223.754,378.915c-2.79-9.645-1.811-21.455,1.763-31.149l-1.577-6.874h-56.845 l10,43.591h48.685C224.959,382.617,224.279,380.731,223.754,378.915z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "223.926,340.892 167.082,340.892 157.082,385.628 213.926,385.628  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#73A3EB"
    },
    d: "M214.797,372.999c-9.015,2.771-18.702,4.197-27.705,0.552 c-8.024-3.249-14.281-10.405-17.028-18.558c-1.259-3.736-2.321-9.407-1.472-14.101h-1.511l-10,44.736h56.845l2.97-13.287 C216.189,372.566,215.488,372.787,214.797,372.999z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M174.628,340.889h-1.41c-0.06-0.14-0.09-0.29-0.14-0.45c-0.05-0.17-0.12-0.3-0.25-0.5 c-0.19-0.3-0.48-0.56-0.83-0.74c-0.32-0.16-0.72-0.23-1.13-0.19c-0.34,0.02-0.75,0.16-1.07,0.38 c-0.36,0.26-0.63,0.65-0.82,1.05c-0.07,0.15-0.12,0.3-0.15,0.45c-0.05,0.22-0.06,0.43-0.02,0.64c0.07,0.39,0.24,0.73,0.49,1.05 c0.11,0.15,0.26,0.26,0.39,0.39c0.14,0.14,0.35,0.29,0.38,0.49c0.02,0.11,0.01,0.26-0.09,0.34c-0.44,0.35-1.07-0.04-1.44-0.34 c-0.4-0.33-0.68-0.77-0.87-1.25c-0.17-0.43-0.22-0.88-0.17-1.32c0.15-1.53,1.45-2.97,2.96-3.26c1.05-0.2,2.1,0.05,2.94,0.72 c0.36,0.29,0.68,0.66,0.9,1.07C174.548,339.859,174.778,340.399,174.628,340.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M183.455,340.889h-1.41c-0.06-0.14-0.09-0.29-0.14-0.45c-0.05-0.17-0.12-0.3-0.25-0.5 c-0.19-0.3-0.48-0.56-0.83-0.74c-0.32-0.16-0.72-0.23-1.13-0.19c-0.34,0.02-0.75,0.16-1.07,0.38 c-0.36,0.26-0.63,0.65-0.82,1.05c-0.07,0.15-0.12,0.3-0.15,0.45c-0.05,0.22-0.06,0.43-0.02,0.64c0.07,0.39,0.24,0.73,0.49,1.05 c0.11,0.15,0.26,0.26,0.39,0.39c0.14,0.14,0.35,0.29,0.38,0.49c0.02,0.11,0.01,0.26-0.09,0.34c-0.44,0.35-1.07-0.04-1.44-0.34 c-0.4-0.33-0.68-0.77-0.87-1.25c-0.17-0.43-0.22-0.88-0.17-1.32c0.15-1.53,1.45-2.97,2.96-3.26c1.05-0.2,2.1,0.05,2.94,0.72 c0.36,0.29,0.68,0.66,0.9,1.07C183.375,339.859,183.605,340.399,183.455,340.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M192.283,340.889h-1.41c-0.06-0.14-0.09-0.29-0.14-0.45c-0.05-0.17-0.12-0.3-0.25-0.5 c-0.19-0.3-0.48-0.56-0.83-0.74c-0.32-0.16-0.72-0.23-1.13-0.19c-0.34,0.02-0.75,0.16-1.07,0.38 c-0.36,0.26-0.63,0.65-0.82,1.05c-0.07,0.15-0.12,0.3-0.15,0.45c-0.05,0.22-0.06,0.43-0.02,0.64c0.07,0.39,0.24,0.73,0.49,1.05 c0.11,0.15,0.26,0.26,0.39,0.39c0.14,0.14,0.35,0.29,0.38,0.49c0.02,0.11,0.01,0.26-0.09,0.34c-0.44,0.35-1.07-0.04-1.44-0.34 c-0.4-0.33-0.68-0.77-0.87-1.25c-0.17-0.43-0.22-0.88-0.17-1.32c0.15-1.53,1.45-2.97,2.96-3.26c1.05-0.2,2.1,0.05,2.94,0.72 c0.36,0.29,0.68,0.66,0.9,1.07C192.203,339.859,192.433,340.399,192.283,340.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M201.11,340.889h-1.41c-0.06-0.14-0.09-0.29-0.14-0.45c-0.05-0.17-0.12-0.3-0.25-0.5 c-0.19-0.3-0.48-0.56-0.83-0.74c-0.32-0.16-0.72-0.23-1.13-0.19c-0.34,0.02-0.75,0.16-1.07,0.38 c-0.36,0.26-0.63,0.65-0.82,1.05c-0.07,0.15-0.12,0.3-0.15,0.45c-0.05,0.22-0.06,0.43-0.02,0.64c0.07,0.39,0.24,0.73,0.49,1.05 c0.11,0.15,0.26,0.26,0.39,0.39c0.14,0.14,0.35,0.29,0.38,0.49c0.02,0.11,0.01,0.26-0.09,0.34c-0.44,0.35-1.07-0.04-1.44-0.34 c-0.4-0.33-0.68-0.77-0.87-1.25c-0.17-0.43-0.22-0.88-0.17-1.32c0.15-1.53,1.45-2.97,2.96-3.26c1.05-0.2,2.1,0.05,2.94,0.72 c0.36,0.29,0.68,0.66,0.9,1.07C201.03,339.859,201.26,340.399,201.11,340.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M209.937,340.889h-1.41c-0.06-0.14-0.09-0.29-0.14-0.45c-0.05-0.17-0.12-0.3-0.25-0.5 c-0.19-0.3-0.48-0.56-0.83-0.74c-0.32-0.16-0.72-0.23-1.13-0.19c-0.34,0.02-0.75,0.16-1.07,0.38 c-0.36,0.26-0.63,0.65-0.82,1.05c-0.07,0.15-0.12,0.3-0.15,0.45c-0.05,0.22-0.06,0.43-0.02,0.64c0.07,0.39,0.24,0.73,0.49,1.05 c0.11,0.15,0.26,0.26,0.39,0.39c0.14,0.14,0.35,0.29,0.38,0.49c0.02,0.11,0.01,0.26-0.09,0.34c-0.44,0.35-1.07-0.04-1.44-0.34 c-0.4-0.33-0.68-0.77-0.87-1.25c-0.17-0.43-0.22-0.88-0.17-1.32c0.15-1.53,1.45-2.97,2.96-3.26c1.05-0.2,2.1,0.05,2.94,0.72 c0.36,0.29,0.68,0.66,0.9,1.07C209.857,339.859,210.087,340.399,209.937,340.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M218.764,340.889h-1.41c-0.06-0.14-0.09-0.29-0.14-0.45c-0.05-0.17-0.12-0.3-0.25-0.5 c-0.19-0.3-0.48-0.56-0.83-0.74c-0.32-0.16-0.72-0.23-1.13-0.19c-0.34,0.02-0.75,0.16-1.07,0.38 c-0.36,0.26-0.63,0.65-0.82,1.05c-0.07,0.15-0.12,0.3-0.15,0.45c-0.05,0.22-0.06,0.43-0.02,0.64c0.07,0.39,0.24,0.73,0.49,1.05 c0.11,0.15,0.26,0.26,0.39,0.39c0.14,0.14,0.35,0.29,0.38,0.49c0.02,0.11,0.01,0.26-0.09,0.34c-0.44,0.35-1.07-0.04-1.44-0.34 c-0.4-0.33-0.68-0.77-0.87-1.25c-0.17-0.43-0.22-0.88-0.17-1.32c0.15-1.53,1.45-2.97,2.96-3.26c1.05-0.2,2.1,0.05,2.94,0.72 c0.36,0.29,0.68,0.66,0.9,1.07C218.684,339.859,218.914,340.399,218.764,340.889z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3,
      fill: "#73A3EB"
    },
    cx: 246.604,
    cy: 390.478,
    rx: 21.973,
    ry: 3.491
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57D9CD"
    },
    d: "M252.105,332.512h-11.003c-4.821,0-8.729,3.908-8.729,8.729v46.718 c0,1.606,1.302,2.908,2.908,2.908h22.646c1.606,0,2.908-1.302,2.908-2.908v-46.718 C260.835,336.42,256.927,332.512,252.105,332.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "#57D9CD"
    },
    d: "M260.215,338.023c-0.063,2.179-0.194,4.256-0.333,6.124 c-0.743,9.935-2.616,20.849-9.169,28.742c-4.519,5.443-12.641,9.552-17.905,2.8c-0.153-0.197-0.292-0.407-0.435-0.613v12.884 c0,1.606,1.302,2.908,2.908,2.908h22.646c1.606,0,2.908-1.302,2.908-2.908v-46.718 C260.835,340.103,260.611,339.02,260.215,338.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M254.418,324.435h-1.012v-3.041c0-0.763-0.619-1.382-1.382-1.382h-10.842 c-0.763,0-1.382,0.618-1.382,1.382v3.041h-1.012c-0.763,0-1.382,0.618-1.382,1.382v5.828c0,0.763,0.619,1.382,1.382,1.382 h15.629c0.763,0,1.382-0.619,1.382-1.382v-5.828C255.8,325.054,255.181,324.435,254.418,324.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#393B6B"
    },
    d: "M254.418,324.435h-1.012v-3.04c0-0.763-0.619-1.382-1.382-1.382h-2.397 c0.041,3.284-0.875,6.667-2.386,8.731c-1.063,1.452-2.533,3.088-4.232,4.282h11.409c0.763,0,1.382-0.619,1.382-1.382v-5.828 C255.8,325.054,255.181,324.435,254.418,324.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57D9CD"
    },
    d: "M236.287,338.132c-0.829,1.327-0.703,3.747-0.067,3.82c0.388,0.044,0.447-1.165,0.777-2.278 c0.211-0.712,0.326-1.269,0.588-1.928C237.846,337.088,236.94,337.085,236.287,338.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57D9CD"
    },
    d: "M235.224,347.649c0.089-0.764,0.198-1.52,0.324-2.262c0.071-0.417,0.158-0.841,0.378-1.202 c0.072-0.118,0.173-0.237,0.311-0.253c0.539-0.062,0.4,2.374,0.404,2.701c0.024,1.998,0.019,3.997,0.027,5.996 c0.008,2.001,0.001,3.966-0.425,5.932c-0.064,0.294-0.52,0.287-0.588,0C234.83,355.077,234.802,351.267,235.224,347.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393B6B"
    },
    d: "M260.618,382.504c0.481,0,0.871,0.39,0.871,0.871l0,0c0,0.481-0.39,0.871-0.871,0.871h-27.786 c-0.481,0-0.871-0.39-0.871-0.871l0,0c0-0.481,0.39-0.871,0.871-0.871"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB4F4F"
    },
    d: "M428.06,221.195h50.459c3.995,0,7.233-3.238,7.233-7.233V187.21c0-3.995-3.239-7.233-7.233-7.233 H428.06c-3.995,0-7.233,3.238-7.233,7.233v26.751C420.827,217.956,424.065,221.195,428.06,221.195z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FB4F4F"
    },
    points: "479.566,233.501 479.566,218.891 464.956,218.891  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD245"
    },
    d: "M463.134,196.166c0-6.083-5.517-10.877-11.82-9.651c-3.902,0.759-7.018,3.945-7.709,7.861 c-0.622,3.523,0.635,6.778,2.933,8.944c0.73,0.688,1.142,1.628,1.077,2.628c-0.065,1.003,0.17,2.093,0.952,3.284 c1.015,1.545,2.682,2.653,4.529,2.715c3.229,0.107,5.88-2.478,5.88-5.682c0-0.007,0-0.013,0-0.02 c-0.005-1.124,0.339-2.222,1.148-3.002C461.978,201.454,463.134,198.947,463.134,196.166z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M455.51,211.503c-0.16,0-0.304-0.113-0.338-0.275c-0.739-3.619-0.722-7.348,0.036-10.959 c-0.968,0.195-1.971,0.026-2.659-0.496c-0.039-0.03-0.079-0.064-0.117-0.1c-0.32,0.24-0.695,0.423-1.095,0.542 c0.011,0.051,0.021,0.101,0.031,0.151c0.699,3.481,0.893,7.033,0.576,10.555c-0.017,0.188-0.17,0.326-0.374,0.312 c-0.19-0.017-0.33-0.184-0.312-0.374c0.311-3.456,0.121-6.941-0.565-10.357c-0.011-0.05-0.02-0.102-0.031-0.152 c-0.555,0.059-1.117-0.003-1.628-0.199c-1.383-0.534-2.2-1.978-1.861-3.288c0.129-0.493,0.518-1.08,1.193-1.115 c0.366-0.031,0.777,0.156,1.168,0.546c0.907,0.905,1.357,2.063,1.651,3.246c0.306-0.096,0.59-0.236,0.832-0.419 c-0.522-0.936-0.727-2.424-0.366-3.351c0.229-0.585,0.674-0.895,1.236-0.837c0.614,0.059,0.89,0.413,1.012,0.7 c0.451,1.05-0.404,2.844-0.941,3.527c-0.008,0.011-0.017,0.023-0.027,0.035c0.011,0.009,0.023,0.019,0.035,0.028 c0.657,0.499,1.621,0.522,2.413,0.29c0.229-0.957,0.512-1.905,0.845-2.839c0.135-0.378,0.283-0.742,0.592-1.039 c0.323-0.309,0.879-0.536,1.407-0.334c0.438,0.169,0.726,0.615,0.717,1.11c-0.007,0.407-0.19,0.762-0.359,1.064 c-0.672,1.185-1.451,1.988-2.382,2.454c-0.078,0.038-0.156,0.075-0.236,0.108c-0.818,3.635-0.863,7.401-0.117,11.052 c0.038,0.187-0.082,0.369-0.269,0.407C455.556,211.501,455.533,211.503,455.51,211.503z M448.427,196.436 c-0.008,0-0.016,0.001-0.024,0.001c-0.323,0.017-0.505,0.386-0.56,0.6c-0.249,0.959,0.397,2.068,1.44,2.47 c0.384,0.148,0.808,0.197,1.226,0.164c-0.269-1.07-0.674-2.105-1.461-2.888C448.814,196.55,448.611,196.436,448.427,196.436z  M457.811,195.915c-0.19,0-0.392,0.098-0.517,0.218c-0.202,0.193-0.31,0.465-0.42,0.773c-0.265,0.74-0.497,1.489-0.693,2.245 c0.681-0.421,1.273-1.084,1.801-2.016c0.129-0.227,0.267-0.491,0.271-0.736c0.003-0.166-0.082-0.38-0.276-0.454 C457.924,195.924,457.868,195.915,457.811,195.915z M452.761,195.617c-0.155,0-0.334,0.065-0.467,0.405 c-0.256,0.655-0.117,1.813,0.226,2.573c0.506-0.731,1.01-2.076,0.747-2.689c-0.051-0.118-0.147-0.257-0.444-0.285 C452.803,195.618,452.782,195.617,452.761,195.617z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E3FF"
    },
    d: "M457.64,211.774h-8.616c-0.325,0-0.589-0.264-0.589-0.589v-0.512 c0-0.325,0.264-0.589,0.589-0.589h8.616c0.325,0,0.589,0.264,0.589,0.589v0.512 C458.229,211.51,457.965,211.774,457.64,211.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E3FF"
    },
    d: "M457.64,213.342h-8.616c-0.325,0-0.589-0.264-0.589-0.589v-0.512 c0-0.325,0.264-0.589,0.589-0.589h8.616c0.325,0,0.589,0.264,0.589,0.589v0.512 C458.229,213.078,457.965,213.342,457.64,213.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E3FF"
    },
    d: "M457.64,214.91h-8.616c-0.325,0-0.589-0.264-0.589-0.589v-0.512 c0-0.325,0.264-0.589,0.589-0.589h8.616c0.325,0,0.589,0.264,0.589,0.589v0.512C458.229,214.646,457.965,214.91,457.64,214.91 z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD245"
    },
    d: "M390.167,257.355h50.459c3.995,0,7.233-3.238,7.233-7.233V223.37 c0-3.995-3.239-7.233-7.233-7.233h-50.459c-3.995,0-7.233,3.239-7.233,7.233v26.751 C382.934,254.117,386.172,257.355,390.167,257.355z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD245"
    },
    points: "441.673,269.661 441.673,255.051 427.063,255.051  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 393.598,
    y: 225.347,
    style: {
      fill: "#FB4F4F"
    },
    width: 28.23,
    height: 4.293
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.598,
    y: 234.059,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.597,
    height: 2.039
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.598,
    y: 240.083,
    style: {
      fill: "#FFFFFF"
    },
    width: 40.517,
    height: 2.039
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.598,
    y: 246.106,
    style: {
      fill: "#FFFFFF"
    },
    width: 42.627,
    height: 2.039
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg76071153670299);
export default __webpack_public_path__ + "static/media/7607115_3670299.2802dc8105df1bc0493a3571d49c57bf.svg";
export { ForwardRef as ReactComponent };